import { render, staticRenderFns } from "./ArrayModal.vue?vue&type=template&id=870a63e6&scoped=true"
import script from "./ArrayModal.vue?vue&type=script&lang=js"
export * from "./ArrayModal.vue?vue&type=script&lang=js"
import style0 from "./ArrayModal.vue?vue&type=style&index=0&id=870a63e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870a63e6",
  null
  
)

export default component.exports